import * as React from 'react';
import { TwitterPicker } from 'react-color';
import Icon from 'common/components/IconFont';
import { Input, Select } from 'antd';
import IconList from './constant';
const InputGroup = Input.Group;
const Option = Select.Option;

// 默认配置
const defaults = {
    color: '#f47373',
    icon: 'search'
};

interface iState {
    icons: any[];
    displayColorPicker: boolean;
}

export default class IconsPicker extends React.Component<any, iState> {

    iconChangeHandler = (data: any) => {
        const { value, onChange } = this.props;
        let newVal = Object.assign(value || { color: '#098' }, {
            icon: data
        });
        onChange && onChange(newVal);
    };

    colorChangeHandler = (data: any) => {
        const { value, onChange, onBlur } = this.props;
        let newVal = Object.assign(value || { icon: 'search' }, {
            color: data && data.hex
        });
        onChange && onChange(newVal);
        onBlur && onBlur(newVal);
        this.colorPickerToggle();
    };

    blurHandler = () => {
        const { value, onBlur } = this.props;
        onBlur && onBlur(value);
    };

    constructor(props: any) {
        super(props);
        this.state = {
            icons: IconList,
            displayColorPicker: false
        };
        const { initialValue, onChange } = this.props;
        onChange(initialValue || defaults);
    }

    colorPickerToggle = () => this.setState({ displayColorPicker: !this.state.displayColorPicker });

    render() {
        const { placeholder, disabled, value } = this.props;
        const { icons, displayColorPicker } = this.state;
        let config = value || defaults;
        return (
            <InputGroup compact className='ant-icon-picker-wrapper'>
                <Select style={{ width: 160 }} disabled={disabled} size="large" value={config.icon}
                    placeholder={placeholder}
                    dropdownMatchSelectWidth={false} dropdownClassName='ant-icon-picker'
                    onChange={this.iconChangeHandler}
                    onBlur={this.blurHandler}>
                    {icons && icons.map((key: any) => (
                        key && <Option key={key} value={`${key}`}>
                            <Icon className={`anticon-${key}`} />
                            <span className='ellipsis ant-icon-picker-text'>{key}</span>
                        </Option>
                    ))}
                </Select>
                <div className="ant-color-picker" style={{ width: 32 }}>
                    <div className="ant-color-picker-container" onClick={this.colorPickerToggle}>
                        <div className="ant-color-picker-btn" style={{ background: config.color }} />
                    </div>
                    {displayColorPicker
                        ? <div className="ant-color-picker-popover">
                            <div className="ant-color-picker-cover" onClick={this.colorPickerToggle} />
                            <TwitterPicker color={config.color} triangle="hide" onChange={this.colorChangeHandler} />
                        </div>
                        : null}
                </div>
            </InputGroup>
        );
    }
}
